import { call, put, takeEvery, debounce } from 'redux-saga/effects';
import { getHistory } from '../../../services/history';
import { setSearchText } from '../../actions/app/search';
import { setSearchText as setUISearchText } from '../../actions/ui/search';
import { SEARCH, ROOT } from '../../../constants/routeTemplates';
import { initialState } from '../../reducers/ui/search';
import { SET_SEARCH_TEXT, SET_SEARCH_FOCUS } from '../../constants/search';

export function* handleSearchFocus({ payload }) {
  if (payload) {
    yield call(enterSearch);
  } else {
    yield call(resetSearch);
  }
}

export function* enterSearch() {
  const history = yield call(getHistory);

  if (history.location.pathname !== SEARCH) {
    const path = { pathname: SEARCH };
    yield call([history, 'replace'], path);
  }
}

export function* resetSearch() {
  yield put(setUISearchText(initialState.text));
  yield put(setSearchText(initialState.text));

  const history = yield call(getHistory);
  if (history.location.pathname === SEARCH) {
    const path = { pathname: ROOT };
    yield call([history, 'replace'], path);
  }
}

export function* syncSearchTextUIAndApp(action) {
  yield put(setSearchText(action.payload));
}

export const DEBOUNCE_TIMEOUT = 400;

export function* search() {
  yield debounce(DEBOUNCE_TIMEOUT, SET_SEARCH_TEXT, syncSearchTextUIAndApp);
  yield takeEvery(SET_SEARCH_FOCUS, handleSearchFocus);
}
